import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { emptyToastMsg, hideNotification } from "../../../Redux/actions";

const Message = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { toastMsgs } = useSelector((state) => state.toastReducer);
  const [successMsg, setSuccessMsg] = useState("");
  const [successMsgId, setSuccessMsgId] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorMsgId, setErrorMsgId] = useState("");

  useEffect(() => {
    checkToastMsg();
  }, [toastMsgs]);
  const checkToastMsg = () => {
    if (toastMsgs.length > 0) {
      const findSuccessInx = toastMsgs.findIndex((p) => p.msgtype == "success");
      if (findSuccessInx > -1) {
        setSuccessMsg(toastMsgs[findSuccessInx].text);
        setSuccessMsgId(toastMsgs[findSuccessInx].id);
      } else {
        setSuccessMsg("");
      }
      const findErrorInx = toastMsgs.findIndex((p) => p.msgtype == "error");
      if (findErrorInx > -1) {
        setErrorMsg(toastMsgs[findErrorInx].text);
        setErrorMsgId(toastMsgs[findErrorInx].id);
      } else {
        setErrorMsg("");
      }
    } else {
      setSuccessMsg("");
      setErrorMsg("");
    }
  };
  let res = null;
  if (successMsg !== "") {
    res = (
      <div
        id="jsFlashMessage"
        class="new_flash_message"
        onClick={() => dispatch(hideNotification(successMsgId))}
      >
        <p>{successMsg}</p>
      </div>
    );
  } else if (errorMsg !== "") {
    res = (
      <div
        id="jsFlashMessage"
        class="new_flash_message_error"
        onClick={() => dispatch(hideNotification(errorMsgId))}
      >
        <p>{errorMsg}</p>
      </div>
    );
  }
  return res;
};
export default Message;
